/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const SOCIAL_MEDIA_ICON: any = {
  instagram: {
    icon: "https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/instagram.png",
  },
  facebook: {
    icon: "https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/facebook-outline.png",
  },
  twitter: {
    icon: "https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/twitter.png",
  },
  linkedin: {
    icon: "https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/linkedin-2.png",
  },
  website: {
    icon: "https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/globe.png",
  },
  youtube: {
    icon: "https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/youtube.png",
  },
  copy: {
    icon: "https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/copy.png",
  },
};
